// extracted by mini-css-extract-plugin
export default {"noSubscriptions":"NoSubscriptions_noSubscriptions__qDbjQ","addSubscription":"NoSubscriptions_addSubscription__W-Of9"};